export default __webpack_public_path__ + "static/media/model1.845238ef.jpg";